export interface SiteMetadata {
  productName: string;
  siteUrl: string;
  description: string;
  previewImagePath: string;
  previewImageUrl: string;
  price: string;
  currency: string;
}

const defaultSiteUrl = 'https://samuelfrench.github.io/form-reorder-passive-site/';

function normalizeSiteUrl(siteUrlOrDomain?: string): string {
  const rawValue = siteUrlOrDomain?.trim();

  if (!rawValue) {
    return defaultSiteUrl;
  }

  const withProtocol = rawValue.startsWith('https://') ? rawValue : `https://${rawValue}`;
  const parsed = new URL(withProtocol);

  if (parsed.protocol !== 'https:') {
    throw new Error('Site URL must use https.');
  }

  parsed.pathname = parsed.pathname === '/' ? '/' : `${parsed.pathname.replace(/\/+$/, '')}/`;
  parsed.search = '';
  parsed.hash = '';

  return parsed.toString();
}

export function buildSiteMetadata(siteUrlOrDomain?: string): SiteMetadata {
  const siteUrl = normalizeSiteUrl(siteUrlOrDomain);

  return {
    productName: 'NCR Reorder Control Pack',
    siteUrl,
    description:
      'Downloadable workbook, printable PDFs, CSV templates, proof checklist, vendor quote form, and pad/carton labels for sequentially numbered NCR and carbonless form reorders.',
    previewImagePath: './ncr-reorder-control-pack-preview.svg',
    previewImageUrl: new URL('ncr-reorder-control-pack-preview.png', siteUrl).toString(),
    price: '99.00',
    currency: 'USD',
  };
}

function getConfiguredSiteUrl(): string | undefined {
  return typeof import.meta.env === 'object' ? import.meta.env.VITE_PUBLIC_SITE_URL : undefined;
}

export const siteMetadata = buildSiteMetadata(getConfiguredSiteUrl());

export function buildProductJsonLd(checkoutUrl?: string, metadata: SiteMetadata = siteMetadata): string {
  const url = checkoutUrl?.trim() || metadata.siteUrl;
  const product = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: metadata.productName,
    description: metadata.description,
    image: metadata.previewImageUrl,
    brand: {
      '@type': 'Brand',
      name: metadata.productName,
    },
    offers: {
      '@type': 'Offer',
      price: metadata.price,
      priceCurrency: metadata.currency,
      url,
      availability: 'https://schema.org/InStock',
    },
  };

  return JSON.stringify(product);
}
